"use strict";

var _regeneratorRuntime = require("/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _model = _interopRequireDefault(require("../model"));

var _user = _interopRequireDefault(require("./user"));

var _userGroup = _interopRequireDefault(require("./user-group"));

var _helpers = require("../helpers");

var _signingKey = _interopRequireDefault(require("./signing-key"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var GroupMembership =
/*#__PURE__*/
function (_Model) {
  _inherits(GroupMembership, _Model);

  function GroupMembership() {
    _classCallCheck(this, GroupMembership);

    return _possibleConstructorReturn(this, _getPrototypeOf(GroupMembership).apply(this, arguments));
  }

  _createClass(GroupMembership, [{
    key: "encryptionPublicKey",
    value: function () {
      var _encryptionPublicKey = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var user, publicKey;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _user.default.findById(this.attrs.username, {
                  decrypt: false
                });

              case 2:
                user = _context.sent;
                publicKey = user.attrs.publicKey;
                return _context.abrupt("return", publicKey);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function encryptionPublicKey() {
        return _encryptionPublicKey.apply(this, arguments);
      }

      return encryptionPublicKey;
    }()
  }, {
    key: "encryptionPrivateKey",
    value: function encryptionPrivateKey() {
      return (0, _helpers.loadUserData)().appPrivateKey;
    }
  }, {
    key: "getSigningKey",
    value: function getSigningKey() {
      var _this$attrs = this.attrs,
          signingKeyId = _this$attrs.signingKeyId,
          signingKeyPrivateKey = _this$attrs.signingKeyPrivateKey;
      return {
        _id: signingKeyId,
        privateKey: signingKeyPrivateKey
      };
    }
  }, {
    key: "fetchUserGroupSigningKey",
    value: function () {
      var _fetchUserGroupSigningKey = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var _id, userGroup, signingKeyId;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _id = this.attrs.userGroupId;
                _context2.next = 3;
                return _userGroup.default.findById(_id);

              case 3:
                userGroup = _context2.sent;
                signingKeyId = userGroup.attrs.signingKeyId;
                return _context2.abrupt("return", {
                  _id: _id,
                  signingKeyId: signingKeyId
                });

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetchUserGroupSigningKey() {
        return _fetchUserGroupSigningKey.apply(this, arguments);
      }

      return fetchUserGroupSigningKey;
    }()
  }], [{
    key: "fetchUserGroups",
    value: function () {
      var _fetchUserGroups = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var _ref, username, memberships, signingKeys, fetchAll, userGroupList, userGroups;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _ref = (0, _helpers.loadUserData)(), username = _ref.username;
                _context3.next = 3;
                return GroupMembership.fetchList({
                  username: username
                });

              case 3:
                memberships = _context3.sent;
                signingKeys = {};
                memberships.forEach(function (_ref2) {
                  var attrs = _ref2.attrs;
                  signingKeys[attrs.signingKeyId] = attrs.signingKeyPrivateKey;
                });
                fetchAll = memberships.map(function (membership) {
                  return membership.fetchUserGroupSigningKey();
                });
                _context3.next = 9;
                return Promise.all(fetchAll);

              case 9:
                userGroupList = _context3.sent;
                userGroups = {};
                userGroupList.forEach(function (userGroup) {
                  userGroups[userGroup._id] = userGroup.signingKeyId;
                });
                return _context3.abrupt("return", {
                  userGroups: userGroups,
                  signingKeys: signingKeys
                });

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function fetchUserGroups() {
        return _fetchUserGroups.apply(this, arguments);
      }

      return fetchUserGroups;
    }()
  }, {
    key: "cacheKeys",
    value: function () {
      var _cacheKeys = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var _ref3, userGroups, signingKeys, groupKeys, self, key;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.fetchUserGroups();

              case 2:
                _ref3 = _context4.sent;
                userGroups = _ref3.userGroups;
                signingKeys = _ref3.signingKeys;
                groupKeys = (0, _helpers.userGroupKeys)();
                _context4.next = 8;
                return _user.default.findById((0, _helpers.loadUserData)().username);

              case 8:
                self = _context4.sent;
                _context4.next = 11;
                return _signingKey.default.findById(self.attrs.personalSigningKeyId);

              case 11:
                key = _context4.sent;
                groupKeys.personal = key.attrs;
                groupKeys.signingKeys = signingKeys;
                groupKeys.userGroups = userGroups;
                localStorage.setItem(_helpers.GROUP_MEMBERSHIPS_STORAGE_KEY, JSON.stringify(groupKeys));

              case 16:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function cacheKeys() {
        return _cacheKeys.apply(this, arguments);
      }

      return cacheKeys;
    }()
  }, {
    key: "clearStorage",
    value: function () {
      var _clearStorage = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                (0, _helpers.clearStorage)();

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function clearStorage() {
        return _clearStorage.apply(this, arguments);
      }

      return clearStorage;
    }()
  }, {
    key: "userGroupKeys",
    value: function userGroupKeys() {
      return (0, _helpers.userGroupKeys)();
    }
  }]);

  return GroupMembership;
}(_model.default);

exports.default = GroupMembership;

_defineProperty(GroupMembership, "className", 'GroupMembership');

_defineProperty(GroupMembership, "schema", {
  userGroupId: String,
  username: {
    type: String,
    decrypted: true
  },
  signingKeyPrivateKey: String,
  signingKeyId: String
});